import * as React from "react";
import { isDefined, isEmpty, Nullable } from "@core/utils";
import parse, { DOMNode, domToReact } from "html-react-parser";

const parseInnerTextOptions = {
  replace: (domNode: DOMNode) => {
    if (domNode.type !== "tag") return;
    if (isEmpty(domNode.children)) return;

    const children = domNode.children as DOMNode[];
    return <>{domToReact(children, parseInnerTextOptions)}</>;
  }
};

export const parseInnerText = (html?: Nullable<string>) => {
  return isDefined(html) ? parse(html, parseInnerTextOptions) : null;
};

const createParseWithoutElementsOptions = (...elements: string[]) => ({
  replace: (domNode: DOMNode) => {
    if (domNode.type !== "tag") return;
    if (!elements.includes(domNode.name)) return;
    if (isEmpty(domNode.children)) return;

    const children = domNode.children as DOMNode[];
    const options = createParseWithoutElementsOptions(...elements);

    return <>{domToReact(children, options)}</>;
  }
});

export const parseWithoutElements = (html?: Nullable<string>, ...elements: string[]) => {
  return isDefined(html) ? parse(html, createParseWithoutElementsOptions(...elements)) : null;
};
